module.exports = __webpack_public_path__ + "media/lobby_selfintro.b05ec233.mp3";